var exports = {
  "p$": "DMChannelView.module__emptyState___LXJMd1",
  "AI": "DMChannelView.module__emptyStateIcon___LXJMd1",
  "vo": "DMChannelView.module__emptyStateTitle___LXJMd1",
  "Li": "DMChannelView.module__emptyStateDescription___LXJMd1",
  "fX": "DMChannelView.module__callParticipantsRow___LXJMd1",
  "gN": "DMChannelView.module__compactCallParticipantsRow___LXJMd1",
  "Gr": "DMChannelView.module__callParticipant___LXJMd1",
  "Gj": "DMChannelView.module__callParticipantAvatar___LXJMd1",
  "I9": "DMChannelView.module__callParticipantRinging___LXJMd1",
  "rV": "DMChannelView.module__call-participant-ring-pulse___LXJMd1",
  "Jn": "DMChannelView.module__callBanner___LXJMd1",
  "nY": "DMChannelView.module__callBannerBody___LXJMd1",
  "c7": "DMChannelView.module__callBannerResizable___LXJMd1",
  "oo": "DMChannelView.module__callControlBarSection___LXJMd1",
  "Pf": "DMChannelView.module__callControlBarInner___LXJMd1",
  "tX": "DMChannelView.module__callControls___LXJMd1",
  "pm": "DMChannelView.module__callBannerMobile___LXJMd1",
  "h8": "DMChannelView.module__callBannerMobileLabel___LXJMd1",
  "ZI": "DMChannelView.module__callControlsMobile___LXJMd1",
  "IX": "DMChannelView.module__compactCallResizeHandle___LXJMd1",
  "rF": "DMChannelView.module__compactCallResizePill___LXJMd1",
};

module.exports = exports;
